<template>
    <section class="quiz-settings">
        <header class="quiz-card-head">
            <span class="quiz-card-head__icon" aria-hidden="true">
                <fa icon="fa-solid fa-file-lines" />
            </span>
            <div>
                <h2 class="quiz-card-head__title">
                    {{ $t('admin.quiz.generalSettings') }}
                </h2>
                <p class="quiz-card-head__hint">
                    {{ $t('admin.quiz.generalSettingsHint') }}
                </p>
            </div>
        </header>

        <div class="quiz-settings__grid">
            <div class="quiz-field">
                <label class="quiz-label required" for="createQuizTitle">
                    {{ $t('common.title') }}
                </label>
                <div class="quiz-input" :class="{ 'is-invalid': titleError }">
                    <fa
                        class="quiz-input__icon"
                        icon="fa-solid fa-file-lines"
                        aria-hidden="true"
                    />
                    <input
                        id="createQuizTitle"
                        type="text"
                        class="quiz-input__control"
                        :value="title"
                        :placeholder="$t('admin.quiz.titlePlaceholder')"
                        :aria-invalid="titleError ? 'true' : 'false'"
                        required
                        @input="$emit('update:title', $event.target.value)"
                    />
                </div>
                <p v-if="titleError" class="quiz-field__error">{{ titleError }}</p>
            </div>

            <div class="score-box" :class="{ 'is-off': !requiredScore }">
                <span class="score-box__icon" aria-hidden="true">
                    <fa icon="fa-solid fa-trophy" />
                </span>
                <div class="score-box__text">
                    <p class="score-box__title" id="createQuizRequiredScoreLabel">
                        {{ $t('admin.quiz.requireScore') }}
                    </p>
                    <p class="score-box__hint">
                        {{ $t('admin.quiz.requireScoreHint') }}
                    </p>
                </div>
                <div class="score-box__controls">
                    <CustomToggle
                        id="createQuizRequiredScore"
                        :model-value="requiredScore"
                        @update:model-value="$emit('update:requiredScore', $event)"
                    />
                    <div
                        class="score-box__percent"
                        :class="{ 'is-disabled': !requiredScore }"
                    >
                        <input
                            id="createQuizApprovalPercentage"
                            type="number"
                            :value="approvalPercentage"
                            :disabled="!requiredScore"
                            :aria-label="$t('admin.quiz.approvalPercentage')"
                            min="0"
                            max="100"
                            @input="$emit('update:approvalPercentage', $event.target.value)"
                        />
                        <span aria-hidden="true">%</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import CustomToggle from '@/components/Form/CustomToggle.vue';

    export default {
        name: 'QuizGeneralSettings',
        components: {
            CustomToggle,
        },
        props: {
            title: {
                type: String,
                default: '',
            },
            requiredScore: {
                type: Boolean,
                default: false,
            },
            approvalPercentage: {
                type: [Number, String],
                default: 70,
            },
            titleError: {
                type: String,
                default: '',
            },
        },
        emits: ['update:title', 'update:requiredScore', 'update:approvalPercentage'],
    };
</script>
